export { groupArrayToObjectByKey }

const groupArrayToObjectByKey = <T extends Record<string, any>>(
  key: keyof T,
  arr: T[],
) => {
  return arr.reduce(
    (acc, item) => {
      const keyValue = item[key]

      if (!acc[keyValue]) {
        acc[keyValue] = []
      }

      acc[keyValue].push(item)
      return acc
    },
    {} as Record<string, T[]>,
  )
}
